<template>
  <div class="price__information"
       :class="{ 'price__information--active' : isShowing }"
       v-if="information"
       :title="information"
       @show="onShow"
       @hide="onHide"
       @click.stop="onShow"
       v-tippy>
    <i class="ic ic-info-bubble"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    price: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isShowing: false
    };
  },
  filters: {
    toDecimal(value) {
      if (value === '') {
        return '0.00';
      }

      return value.toFixed(2);
    },
    addCurrency(value) {
      if (value === '') {
        return '';
      }

      return `€${value}`;
    },
    switchToComma(value) {
      if (value === '') {
        return '';
      }

      return value.replace('.', ',');
    }
  },
  computed: {
    ...mapGetters({
      activePackageConfig: 'packages/getActivePackageConfig'
    }),
    flatPrice() {
      return this.price / (1 + this.activePackageConfig.alternativeTaxes.default);
    },
    azoresPrice() {
      return this.flatPrice * (1 + this.activePackageConfig.alternativeTaxes.azores);
    },
    madeiraPrice() {
      return this.flatPrice * (1 + this.activePackageConfig.alternativeTaxes.madeira);
    },
    information() {
      const filters = this.$options.filters;

      return `<ul>
        <li>Preço s/IVA: ${filters.switchToComma(filters.addCurrency(filters.toDecimal(this.flatPrice)))}</li>
        <li>Preço Madeira: ${filters.switchToComma(filters.addCurrency(filters.toDecimal(this.madeiraPrice)))}</li>
        <li>Preço Açores: ${filters.switchToComma(filters.addCurrency(filters.toDecimal(this.azoresPrice)))}</li>
      </ul>`;
    }
  },
  methods: {
    onShow() {
      this.isShowing = true;
    },
    onHide() {
      this.isShowing = false;
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/sass/tools/font';
  @import '../../assets/sass/settings/colors';

  .price__information {
    position: relative;

    display: inline;

    width: 1rem;
    min-width: 1rem;
    height: 1rem;

    margin-left: .6875rem;

    font-size: 1rem;

    color: $color-silver-darkest;

    cursor: help;
    pointer-events: all;

    transition: color 250ms ease-in;

    .device-kiosk & {
      width: 1.875rem;
      min-width: 1.875rem;
      height: 1.875rem;

      margin-left: 1.5625rem;
      margin-right: 1.5625rem;

      font-size: 1.875rem;
    }

    &:before {
      content: '';
      position: absolute;
      top: -.5rem;
      right: -.5rem;
      bottom: -.5rem;
      left: -.5rem;
    }

    &--active {
      color: $color-purple-ash !important;
    }

    .ic {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .choice--active & {
      color: $color-purple-ash-lighter;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/components/PriceInformation.vue